/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';

import MultiChoiceOption from './MultiChoiceOption';
import PercentageIndicator from 'edrolo/components/common/PercentageIndicator';

import style from './MultiChoiceResponse.scss';
import { quizStatsPropType } from './helpers';

const QuizStats = ({ stats }) => {
  const percentCorrect = Math.round(stats.get('percent_correct'));
  const statText = `${percentCorrect}% of people answered this question correctly`;
  return (
    <span>
      <PercentageIndicator
        className="bg-light-green"
        value={percentCorrect}
        showValue={false}
        orientation="horizontal"
      />
      {statText}
    </span>
  );
};

const MultiChoiceResponse = ({
  stats,
  answers,
  allowMultiSelect,
  showResult,
  checked,
  onChange,
  isSlideshow,
}) => {
  return (
    <div
      className={cx('response multiple-choice clearfix', {
        [style.slideshow]: isSlideshow,
      })}
    >
      <ol className="left">
        {answers.map((answer) => (
          <MultiChoiceOption
            allowMultiSelect={allowMultiSelect}
            key={answer.get('id')}
            label={answer.get('text')}
            value={answer.get('id')}
            showResult={showResult}
            checked={_.includes(checked, answer.get('id'))}
            isCorrect={answer.get('is_correct')}
            onChange={onChange}
          />
        ))}
      </ol>
      <div className="right">{stats ? <QuizStats stats={stats} /> : null}</div>
    </div>
  );
};

QuizStats.propTypes = {
  stats: quizStatsPropType,
};

MultiChoiceResponse.propTypes = {
  checked: PropTypes.array,
};

MultiChoiceResponse.defaultProps = {
  checked: [],
};

export default MultiChoiceResponse;
